// Glowy Mail panel API yardımcıları — uçlar: /api/email-platform/* (sadece Efe)
const API = 'https://api.glowytics.com';

export async function mailApi(brandId, path, { method = 'GET', body, query } = {}) {
  const qs = new URLSearchParams({ brandId, ...(query || {}) });
  const r = await fetch(`${API}/api/email-platform${path}?${qs}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await r.json(); } catch (e) { /* gövde yok */ }
  if (!r.ok) throw new Error(data?.error || (r.status === 403 ? "You don't have access to this page" : `HTTP ${r.status}`));
  return data;
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const fmtNum = (n) => Number(n || 0).toLocaleString('en-US');
export const pct = (a, b) => (b ? `${((a / b) * 100).toFixed(1)}%` : '—');

export const MERGE_TAGS = [
  ['{{first_name}}', 'First name'],
  ['{{first_name|there}}', 'First name, with fallback'],
  ['{{last_name}}', 'Last name'],
  ['{{email}}', 'Email address'],
  ['{{unsubscribe_url}}', 'Unsubscribe link (added to the footer automatically if missing)'],
];

export const STARTER_HTML = `<!doctype html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
</head>
<body style="margin:0;padding:0;background:#f4f4f5">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f4f4f5">
    <tr><td align="center" style="padding:32px 16px">
      <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:12px">
        <tr><td style="padding:40px 40px 8px;font-family:Arial,Helvetica,sans-serif">
          <h1 style="margin:0;font-size:26px;line-height:32px;color:#111827">Merhaba {{first_name|}},</h1>
        </td></tr>
        <tr><td style="padding:12px 40px 8px;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:24px;color:#374151">
          Yeni sezon ürünlerimiz yayında. Size özel seçkiyi keşfedin.
        </td></tr>
        <tr><td style="padding:24px 40px 40px">
          <a href="https://example.com" style="display:inline-block;background:#111827;color:#ffffff;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:bold;text-decoration:none;padding:14px 28px;border-radius:8px">Alışverişe başla</a>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;

// Önizlemede birleştirme etiketlerini örnek veriyle doldur
export function previewHtml(html, sample = { first_name: 'Ayşe', last_name: 'Yılmaz', email: 'ayse@example.com' }) {
  return String(html || '').replace(/\{\{\s*([a-zA-Z0-9_.]+)\s*(?:\|([^}]*))?\}\}/g, (m, key, fb) => {
    if (key === 'unsubscribe_url') return '#';
    const v = sample[key];
    return v == null || v === '' ? (fb ?? '') : v;
  });
}
